import Payment from "./payment/payment.vue";
import axios from "axios";

import toll from "../../services/toll";
import sales from "../../services/sales";
import messageDialog from "../../components/message-dialog.vue";
import {cents} from "../../filters/number";
import modalAddress from "../../components/modal-address.vue";
import Contracts from "../../services/contracts";
import TagService from "../../services/tag.js";
import Auth from "../../services/auth";
import Financial from "../../services/financial";
import * as utils from "../../utils.js";
import * as obj from "./adhesion/objects";
import C from "./constantes";
import Conveniado from '../../services/conveniado-service';
import Param from '../../services/param'

export default {
  props: ["account", "order", "showAddress", "addressInit", "reprocess", "contract", "currentBalance", "rodosol", "disablePayment", "skipBillingSection"],
  data() {
    return {
      blackFriday: ['FR01', 'FR02', 'FR03', 'FR04', 'FR05', 'FR06', 'FR07', 'FR08', 'FR09', 'FR10'],
      disableBf: false,
      address: this.address,
      loading: undefined,
      orderShipmentTracking: undefined,
      urlPayment: undefined,
      showVehicle: false,
      listVehicles: [],
      statusPedido: {},
      showModal: false,
      secureCodeCreditCard: undefined,
      dataCorteReprocessamento: undefined,
      newTypePayment: undefined,
      reprocessed: false,
      orderResult: undefined,
      paymentSelected: obj.payment(),
      showEntries: false,
      whereToDelivery: "0",
      cupom: this.order.promotionCode,
      promotionCode: this.order.promotionCode,
      totalComDesconto: this.order.price,
      descontoCupom: 0,
      erroCupom: 0,
      nameDelivery: {
        61800016: "MSVIA",
        61801283: "RodoNorte",
      },
      shipmentType: undefined,
      frete: undefined,
      promoBF: false,
      onoffswitch: undefined,
      limitValue: undefined,
      limitPercent: undefined,
      emailBlured: false,
      valid: true,
      conveniados: [],
      resultBalance: undefined,
      percentValid: undefined,
      toggle: false,
      cpm: {
        contractPaymentMethodId: undefined,
        error: this.disablePayment || this.skipBillingSection ? undefined : "Verifique o preenchimento dos campos",
      },
      resolveConfirm: undefined,
      selectedAddress: {},
      addresses: [],
      prazoEntrega: "",
      paymentMethodsAuthorized: {},
      termsAccepted: false,
      termsAdhesionShowError: false,
      tagInHandStates: [],
      tagReservaDisponivel: false,
      saldoDisponivel: 0,
    };
  },
  computed: {
    requiresAdhesionTermsAcceptance() {
      if (!this.orderResult || this.cpm.error) {
        return false;
      }
      if (this.orderResult.salesOrderId) {
        return false;
      }
      if (this.orderResult.salesType === "RECHARGE") {
        return false;
      }
      if (this.orderResult.salesType !== "ADHESION") {
        return false;
      }
      return this.skipPaymentFlow || this.cpm.paymentMethod != null;
    },
    skipPaymentFlow() {
      return this.disablePayment === true || this.skipBillingSection === true;
    },
    addressOrderDelivery(){
      return this.orderResult.salesOrderShipment.deliveryAddress
    },
    currentUser() {
      return Auth.currentUser;
    },
    possuiTagReserva() {
      return !!(Auth.currentUser && Auth.currentUser.possuiTagReserva);
    },
    mostrarValores() {
      return (
        this.orderResult.salesType == "RECHARGE" ||
        this.shipmentType ||
        this.reprocess
      );
    },
    mostrarPagamento() {
      return this.orderResult.salesType == "RECHARGE" || this.shipmentType;
    },
    email() {
      if (this.currentUser) {
        return this.currentUser.email2;
      } else if (this.account.email2) {
        return this.account.email2;
      } else if (this.account.company) {
        return this.account.accountAuthentication.login;
      }
    },
    nomePfPj() {
      if (this.account && this.account.person) {
        return this.account.person.name + " " + this.account.person.lastName;
      } else if (this.account && this.account.company) {
        return this.account.company.companyName;
      } else if (this.currentUser.company) {
        return this.currentUser.company.companyName;
      } else {
        return (
          this.currentUser.person.name + " " + this.currentUser.person.lastName
        );
      }
    },
    notAproved() {
      return this.$route.query.notAproved;
    },
    hasAnyPaymentMethodAvailable() {
      if (!this.account || !this.account.taxIdNumber) {
        return this.hasAnyPaymentMethodInPlan();
      }

      const planId = this.orderResult && this.orderResult.planId;
      if (!planId) {
        return true;
      }

      const typesAllowed = this.$store.getters.getPaymentsTypesByPlan(planId);

      if (!this.paymentMethodsAuthorized || Object.keys(this.paymentMethodsAuthorized).length === 0) {
        if (!typesAllowed) {
          return true;
        }
        return this.hasAnyPaymentMethodInPlan();
      }

      if (!typesAllowed) {
        return true;
      }

      const isAuthorized = (method) => {
        if (!this.paymentMethodsAuthorized.hasOwnProperty(method)) {
          return true;
        }
        return this.paymentMethodsAuthorized[method] === true;
      };

      const hasDC = isAuthorized('DC') && typesAllowed.bankAccount;
      const hasCC = isAuthorized('CC') && typesAllowed.creditCard;
      const hasBC = isAuthorized('BC') && typesAllowed.bankBill;
      const hasDO = isAuthorized('DO') && typesAllowed.doc;
      const hasTE = isAuthorized('TE') && typesAllowed.ted;
      const hasPX = isAuthorized('PX');
      const hasCR = isAuthorized('CR');

      return hasDC || hasCC || hasBC || hasDO || hasTE || hasPX || hasCR;
    },

    hasAnyPaymentMethodInPlan() {
      const planId = this.orderResult && this.orderResult.planId;
      if (!planId) {
        return true;
      }

      const typesAllowed = this.$store.getters.getPaymentsTypesByPlan(planId);
      if (!typesAllowed) {
        return true;
      }

      return typesAllowed.bankAccount ||
             typesAllowed.creditCard ||
             typesAllowed.bankBill ||
             typesAllowed.doc ||
             typesAllowed.ted;
    },
    contractId() {
      return this.orderResult && this.orderResult.contract;
    },
    isCaminhoParana() {
      if (this.orderResult) {
        return utils.isCaminhoParana(this.orderResult.planId);
      }
      return;
    },

    bankBillOption() {
      var options = this.$store.getters.getPaymentsTypesByPlan(
        this.orderResult.planId
      );
      return options.bankBill;
    },

    isPlanPrePF() {
      let plans = [21, 22];
      return plans.find(p => {
        return p == this.order.planId;
      });
    },

    isPlanPrePJ() {
      let plans = [31, 32, 45, 55];
      return plans.find(p => {
        return p == this.order.planId;
      });
    },

    showFreteExpresso() {
      return sessionStorage.getItem('promoCheck') != '#SENFF2020' && !this.reprocess && this.orderResult.planId != null;
    },

    showRetiradaEmMaos() {
      return (
        sessionStorage.getItem("promoCheck") != "#SENFF2020" &&
        !this.reprocess &&
        this.orderResult.planId != null
      );
    },

    isAnyTagActivating() {
      return this.tagInHandStates.some((s) => s && (s.loading || s.success));
    },

    anyTagActivationSuccess() {
      return this.tagInHandStates.some((s) => s && s.success);
    },

    cellPhone() {

      if (this.currentUser) {
        if ((!this.currentUser.nroCellphone && !this.currentUser.dddCellphone && !this.orderResult.salesType != "ADHESION") || (this.currentUser.dddCellphone == "null" && this.currentUser.nroCellphone == "null" && this.orderResult.salesType != "ADHESION")) {
          this.currentUser.dddCellphone = "";
          this.currentUser.nroCellphone = "";
          return;
        } else {
          return (
            "(" +
            this.currentUser.dddCellphone +
            ") " +
            this.currentUser.nroCellphone
          );
        }
      }
      return "(" + this.account.dddCellphone + ") " + this.account.nroCellphone;
    },

    devePreencherEndereco() {
      return (
        this.showAddress &&
        !this.shipmentType &&
        (this.orderResult.planId == 21 || this.orderResult.planId == 22)
      );
    },
  },

  watch: {
    address() {
      this.getPrazoEntrega()
    },
      cupom() {
        var cupomExiste = this.blackFriday.indexOf(this.cupom)
        cupomExiste != -1 ? this.disableBf = true : this.disableBf = false
      },
      cpm() {
        this.$emit("input", this.cpm);
      },
      'account.taxIdNumber'(newVal) {
        if (this.skipPaymentFlow) {
          this.paymentMethodsAuthorized = {};
          return;
        }
        if (newVal) {
          this.loadPaymentMethodAuthorizations(newVal);
        } else {
          this.paymentMethodsAuthorized = {};
        }
      },
      orderResult: {
        handler(newVal) {
          this.checkTagReservaDisponivel();
          if (this.skipPaymentFlow) {
            return;
          }
          if (newVal && this.account && this.account.taxIdNumber) {
            this.loadPaymentMethodAuthorizations(this.account.taxIdNumber);
          }
        },
        deep: true
      },
    anyTagActivationSuccess(newVal) {
      this.$emit("tag-activation-state", newVal);
    },
    listVehicles(newVal) {
      const prev = this.tagInHandStates || [];
      this.tagInHandStates = (newVal || []).map((_v, i) => {
        const keep = prev[i];
        return keep ? keep : { serialNumber: "", error: "", loading: false, success: false };
      });
    },
    'contract.currentBalance.currentBalance': function (val, oldVal) { this.calculatePercentValid() },
    termsAccepted(val) {
      if (val) {
        this.termsAdhesionShowError = false;
      }
    },
    shipmentType(newVal) {
      this.$emit("shipment-type-change", newVal);
      _.remove(this.order.products, function (o) {
        return o.productId == 31;
      });

      if (this.shipmentType == 3) {
        $('#ModalConveniados').modal('show');

        this.loading = Conveniado.listaConveniados().then(resp => {
          this.conveniados = resp.listaConveniados;
        }).catch(err => {

        });
      }

      if (this.shipmentType == 2) {
        this.order.products.push({
          productId: 31,
          productName: "FRETE",
          valueUnit: this.frete.cobrancaExp,
          quantity: 1,
          valueTotal: this.frete.cobrancaExp
        });
      }
      if (this.shipmentType != 4) {
        this.tagInHandStates = (this.listVehicles || []).map(() => ({
          serialNumber: "",
          error: "",
          loading: false,
          success: false,
        }));
      }
      this.calculateTotal();
    },
  },
  created() {
    if (this.addressInit) {
      this.address = this.addressInit;
      this.selectedAddress = this.addressInit;
    } else {
      this.address = Auth.currentUser && Auth.currentUser.address;
      this.selectedAddress = this.address;
    }

    if (this.account && this.account.taxIdNumber && !this.skipPaymentFlow) {
      this.loadPaymentMethodAuthorizations(this.account.taxIdNumber);
    }

    this.$store.dispatch('getPlans').catch(err => {
      console.error('Erro ao carregar planos:', err);
    });
  },

  mounted: async function () {
    const larguraTela =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    this.calculatePercentValid();

    if (this.$route.query.promoId == 'FERIAS_2022') {
      await this.blackFridayCheck();
    }

    this.orderResult = this.order;
    this.listVehicles = this.order.vehicles;
    this.tagInHandStates = (this.listVehicles || []).map(() => ({
      serialNumber: "",
      error: "",
      loading: false,
      success: false,
    }));
    this.checkTagReservaDisponivel();

    if (
      this.showAddress &&
      this.orderResult &&
      !this.order.salesOrderId &&
      this.orderResult.salesType !== "RECHARGE" &&
      this.orderResult.salesType !== "MIGRATIONPLAN" &&
      !utils.isCaminhoParana(this.orderResult.planId) &&
      this.order.promotionCode !== "CAMINHOSDOPARANA" &&
      (this.shipmentType === undefined ||
        this.shipmentType === null ||
        this.shipmentType === "")
    ) {
      this.shipmentType = "1";
    }

    if (this.orderResult.salesType != "RECHARGE" && this.salesType == 'MIGRATIONPLAN') {
      if (!this.reprocess && sessionStorage.getItem('promoCheck') != '#SENFF2020') {
        await this.checkCovid();
      }
    }

    const recargaProduto = this.orderResult.products.filter(product => product.productId === 2);
    const adesaoProduto = this.orderResult.products.filter(product => product.productId === 1);
    const taxaRecargaProduto = this.orderResult.products.filter(product => product.productId === 3);
    const adesaoVeiculoAdicional = this.orderResult.products.filter(product => product.productId === 4);

    if (
      (this.orderResult.salesType === "ADHESION" || this.orderResult.salesType === "ADHESIOACONTRACTADDITIONAL") &&
      recargaProduto[0].valueTotal >= 20000 &&
      this.orderResult.planId === 22
    ) {
      let hasPlanId22 = false;

      if (this.orderResult.salesType === "ADHESIOACONTRACTADDITIONAL") {
        const contracts = await Contracts.findAll(this.currentUser.moveMaisId);

        for (const contract of contracts) {
          if (contract.plan && contract.plan.planId === 22) {
            hasPlanId22 = true;
            break;
          }
        }

        if (hasPlanId22) {
          return;
        }
      }

      if (!hasPlanId22) {
        try {
          const res = await Param.getGeneralParameter({ key: 'TOTAL_ADHESION' });
          if (res.status.code === 0 && res.value != "") {
            this.descontoCupom = 2;
            this.cupom = res.value;
            this.order.promotionCode = res.value;

            if (this.orderResult.salesType === "ADHESION") {
              adesaoProduto[0].valueUnit = 0;
              adesaoProduto[0].valueTotal = 0;
            } else {
              adesaoVeiculoAdicional[0].valueUnit = 0;
              adesaoVeiculoAdicional[0].valueTotal = 0;
            }

            taxaRecargaProduto[0].valueUnit = 0;
            taxaRecargaProduto[0].valueTotal = 0;
          }
        } catch (err) {
          console.error("Falha ao consultar promocao total ativa");
        }
      }
    }

    if (this.promotionCode) {
      this.calculateDiscount();
    }

    if (this.showAddress) {
      let uf = { uf: this.address.state };
      const res = await sales.findByUf(uf);
      this.frete = res.frete;
    }

    this.calculateTotal();
    this.getPrazoEntrega();
  },
  methods: {
    checkTagReservaDisponivel() {
      const possui = !!(Auth.currentUser && Auth.currentUser.possuiTagReserva);
      if (!possui) {
        this.saldoDisponivel = 0;
        this.tagReservaDisponivel = false;
        return;
      }
      const moveMaisId = Auth.currentUser.moveMaisId;
      const cnpj = Auth.currentUser.taxIdNumber;
      if (!moveMaisId || !cnpj) {
        this.saldoDisponivel = 0;
        this.tagReservaDisponivel = false;
        return;
      }
      TagService.getSaldoTagReservaByMoveMaisId(moveMaisId)
        .then((saldos) => {
          const entrada = (saldos || []).find((s) => s && s.cnpj === cnpj);
          const saldoLiq =
            entrada && entrada.saldoDisponivelLiquido != null ? entrada.saldoDisponivelLiquido : 0;
          this.saldoDisponivel = Math.max(0, saldoLiq);
          this.tagReservaDisponivel = this.saldoDisponivel > 0;
        })
        .catch(() => {
          this.saldoDisponivel = 0;
          this.tagReservaDisponivel = false;
        });
    },
    canActivateTagInHand(index) {
      const s = this.tagInHandStates[index];
      if (!s || this.shipmentType != 4) return false;
      if (s.loading || s.success) return false;
      if (!s.serialNumber || s.serialNumber.length === 0) return false;
      if (this.isAnyTagActivating && !s.loading) return false;
      return true;
    },
    handleTagSerialNumberInput(index) {
      const s = this.tagInHandStates[index];
      if (!s) return;
      s.serialNumber = (s.serialNumber || "").replace(/\D/g, "");
      s.error = "";
      s.success = false;
    },
    validateTagInHand(vehicle, index) {
      const s = this.tagInHandStates[index];
      if (!s) return;

      s.error = "";
      s.success = false;

      const onlyNumbers = (s.serialNumber || "").replace(/\D/g, "");
      s.serialNumber = onlyNumbers;

      if (!onlyNumbers) {
        s.error = "Digite o número da TAG.";
        return;
      }

      if (onlyNumbers.length < 8) {
        s.error = C.MSG_02_TAG_NOT_FOUND;
        return;
      }

      if (!vehicle || !vehicle.plate) {
        s.error = "Veículo não disponível para ativação.";
        return;
      }

      const moveMaisId = Auth.currentUser && Auth.currentUser.moveMaisId;
      if (!moveMaisId) {
        s.error = "Não foi possível identificar o usuário. Tente novamente.";
        return;
      }

      s.loading = true;

      const isReplaceTag = this.orderResult && this.orderResult.salesType === "REPLACETAG";

      const handleSuccess = (resp) => {
        const ok =
          (resp && resp.status === 0) ||
          (resp && resp.code === 0) ||
          (resp && resp.status && resp.status.code === 0) ||
          (resp && resp.salesOrder);
        if (ok) {
          s.success = true;
        } else {
          s.error = C.MSG_02_TAG_NOT_FOUND;
        }
      };

      const handleError = () => {
        s.error = C.MSG_02_TAG_NOT_FOUND;
      };

      const done = () => {
        s.loading = false;
      };

      if (isReplaceTag) {
        const vehicleForReq = Object.assign({}, vehicle, {
          tagSerialNumber: onlyNumbers,
          tag: null,
        });
        const payload = {
          moveMaisId,
          contractId: this.contractId,
          deliveryAddressId: this.address && this.address.addressId,
          // Sem fluxo de pagamento não envia o cpm placeholder de validação.
          contractPaymentMethod: this.skipPaymentFlow ? undefined : this.cpm,
          value: this.totalComDesconto,
          _interface: "WEBSITE",
          vehicles: [vehicleForReq],
          shipmentType: 4,
          logisticsDistribution: null,
          salesTypeExt: "SOL_TAG",
        };
        return sales
          .requestTagReplacement(payload, { skipCheckout: true })
          .then(handleSuccess)
          .catch(handleError)
          .then(done);
      }

      const payload = {
        plate: vehicle.plate,
        modelId: vehicle.model && vehicle.model.modelId,
        categoryArtespId: vehicle.categoryAxes && vehicle.categoryAxes.categoryAxesId,
        tagSerialNumber: onlyNumbers,
        moveMaisId,
        contractId: this.contractId,
      };
      if (this.shipmentType == 4) {
        payload.sales_type = "SOL_TAG";
      }

      return TagService.activateTagSite(payload)
        .then(handleSuccess)
        .catch(handleError)
        .then(done);
    },
    loadPaymentMethodAuthorizations(taxIdNumber) {
      if (this.skipPaymentFlow) {
        this.paymentMethodsAuthorized = {};
        return;
      }
      if (!taxIdNumber) {
        this.paymentMethodsAuthorized = {};
        return;
      }

      Financial.getPaymentMethodUnauthorized(taxIdNumber).then(authResponse => {
        const authMethods = authResponse.data.data.paymentMethods;

        this.paymentMethodsAuthorized = {};

        authMethods.forEach(method => {
          this.paymentMethodsAuthorized[method.shortName] = method.authorized === 1;
        });

        this.$nextTick(() => {
          this.$forceUpdate();
        });
      }).catch(error => {
        console.error('Erro ao buscar autorizações:', error);
        this.paymentMethodsAuthorized = {};
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      });
    },
    async getPrazoEntrega() {
      await axios.get(`/v2/prazo-entrega/${this.address.zipCode}`).then(res => {
        this.prazoEntrega = res.data.prazoEntrega;
      })
    },
    addNewAddress() {
      this.showModal = true;
      $("#modal-address").modal("show");
    },

    deliveryAddress(fn) {

      this.address = fn;
    },

    allAddresses(addresses) {

      this.addresses = addresses;
    },

    showConfirmModal() {
      if (this.skipPaymentFlow) {
        return Promise.resolve("YES");
      }

      let vm = this;
      if(this.cpm.paymentMethod.paymentMethodId != 120){
      $("#modalPurchase").modal();
      $("#modalPurchase").on("hidden.bs.modal", function (e) {
        vm.resolveConfirm("NO");
      });

      }else{
      $("#modalPurchase").modal();
      $("#modalPurchase").modal("hide");
      $("#modalPurchase").on("hidden.bs.modal", function (e) {
        vm.resolveConfirm("YES");
      });
    }

      return new Promise((resolve, reject) => {
        this.resolveConfirm = resolve;

      });
    },

    endModal(option) {
      $("#modalPurchase").on("hidden.bs.modal", function (e) {});
      $("#modalPurchase").modal("hide");
      this.resolveConfirm(option);
    },

    formatAddress() {
      return (
        this.address.address +
        " " +
        this.address.number +
        ", " +
        this.address.city
      );
    },

    getCurrentBalance(){
      return cents(this.contract.currentBalance.currentBalance);
    },


    getPayment() {
      if (this.skipPaymentFlow) {
        return undefined;
      }
      return this.cpm
    },

    getInfos() {
      this.address.whereToDelivery = this.whereToDelivery;

      if (this.shipmentType == 4 && !this.anyTagActivationSuccess) {
        messageDialog.show({
          title: "Ativação da TAG",
          message: "Informe e valide o número da TAG para continuar.",
        });
        return Promise.reject("");
      }

      if (this.cupom && this.order.promotionCode != this.cupom) {

        messageDialog.show({
          title: 'Cupom inválido',
          message: 'Por favor coloque um cupom válido ou remova o cupom inválido',
        });

        return Promise.reject('');
      }

      if (this.requiresAdhesionTermsAcceptance && !this.termsAccepted) {
        this.termsAdhesionShowError = true;
        messageDialog.show({
          title: "Termos de contratação",
          message:
            "É necessário ler e concordar com os termos para realizar a adesão",
        });
        this.$nextTick(() => {
          const el = document.getElementById("terms");
          if (el && el.scrollIntoView) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        });
        return Promise.reject("");
      }
      this.termsAdhesionShowError = false;

      if (!this.showAddress) {
        return Promise.resolve({
          promotionCode: this.cupom,
          whereToDelivery: this.whereToDelivery,
          shipmentType: this.shipmentType
        });
      }
      if (this.showAddress && !this.shipmentType && !this.orderResult.salesType == 'MIGRATIONPLAN' && (this.orderResult.planId == 21 || this.orderResult.planId == 22)) {
        messageDialog.show({
          title: "Forma de envio",
          message: "Favor selecionar a forma de envio"
        });
        return Promise.reject("");
      }
        let message = "";
        if (this.isCaminhoParana) {
          message = ' Confirma a retirada da(s) tag(s) na Base de apoio operacional da Concessionária Caminhos do Paraná. \nRodovia 277, Km 249, 700\nIrati - PR?\nAtendimento: Segunda a Sexta, das 8 às 17 h. <br><br> <div class="info-block-box"><div class="inline"><img src="static/exclamation-mark.png" alt="" width="40px"></div><p class="inline">Para utilizar nossos serviços e fazer novas recargas, você deve primeiro ativar sua(s) TAG(s) que está a caminho.</p></div>';
        } else if (this.whereToDelivery != "0") {
          message = 'Confirma retirada das TAGs no(a) ' + this.nameDelivery[this.whereToDelivery] + '?<br><br> <div class="info-block-box"><div class="inline"><img src="static/exclamation-mark.png" alt="" width="40px"></div><p class="inline">Para utilizar nossos serviços e fazer novas recargas, você deve primeiro ativar sua(s) TAG(s) que está a caminho.</p></div>';
        } else if ((this.shipmentType != null) && (this.shipmentType == 3)) {
          message = 'Confirma a retirada da TAG em mãos em um Parceiro Move Mais?'
        } else if(this.orderResult.salesType == 'MIGRATIONPLAN'){
          message = 'Deseja prosseguir com a migração?'
        } else if (this.skipPaymentFlow) {
          message = 'Confirma a entrega da(s) TAG(s) no endereço: ' + this.formatAddress() + '?';
        } else {
          message = 'Após a aprovação do seu pagamento, você receberá seu(s) TAG(s) no endereço: ' + this.formatAddress();
        }

        return this.showConfirmModal().then((e) => {
          if (
            e == "YES" &&
            this.shipmentType != null &&
            this.shipmentType == 3


          ) {
            return {
              address: this.address,
              allAddresses: this.addresses,
              promotionCode: this.cupom,
              whereToDelivery: this.whereToDelivery,
              shipmentType: this.shipmentType,
              tagSerialNumber:
                (this.tagInHandStates.find((s) => s && s.success) || {}).serialNumber || "",
            };

          }
           else if (e == "YES") {
            return {
              address: this.address,
              allAddresses: this.addresses,
              promotionCode: this.cupom,
              whereToDelivery: this.whereToDelivery,
              shipmentType: this.shipmentType,
              tagSerialNumber:
                (this.tagInHandStates.find((s) => s && s.success) || {}).serialNumber || "",
            };
          } else

          return Promise.reject("");
        }).catch(() => {});

    },

    toogleModal() {
      this.showVehicle = !this.showVehicle;
    },
    canReprocess() {
      return (
        (!this.expiredCardDate &&
          this.orderResult.status.statusId == 3 &&
          parseInt(this.dataCorteReprocessamento) < new Date().getTime()) ||
        (this.orderResult.paymentMethod.type == "BC" &&
          !this.orderResult.bankBillUrl &&
          this.orderResult.price > 0)
      );
    },
    showModalReprocessPayout() {
      this.showModal = true;
    },
    isDescont(product, value) {
      return product.productId == 11 ? -1 * value : value;
    },
    showVehiclesPlates(product) {
      let productsException = [1, 4, 6];
      return (
        this.orderResult.promotionCode != "CAMINHOSDOPARANA" &&
        productsException.includes(product.productId)
      );
    },
    goToOrders(sucess) {
      this.$router.push({
        name: "requests"
      });
    },
    getTolls(state, associateId) {
      this.loading = toll
        .getTollsByState(state)
        .then((res) => {
          this.entries = _.filter(res, (o) => {
            return o.associateId == associateId;
          });
          this.showEntries = true;
        })
        .catch((err) => {

        });
    },

    calculateDiscount() {
      var findRecharge = this.order.products.find(product => product.productId == 2)
      var valueByPlan = this.order.planId == 22 ? 9999 : this.order.planId == 32 ? 24999 : 0
      var checkBfParams = this.disableBf && findRecharge.valueTotal < valueByPlan ? true : false
      if(!checkBfParams){
        this.erroCupom = "";
        let resolveTemp = undefined;

        let promotionCode = this.cupom;
        this.setPromotion(this.cupom)
        let planId = this.orderResult.planId;
        let request = {
          promotionCode,
          planId,
        };
        request.salesType = this.order.salesType;

        let discountRecharge = undefined;
        let discountAdhesion = undefined;
        let countDiscount = 0;

        let promise = sales
          .calculateDiscount(request)
          .then((response) => {
            discountAdhesion = response;
            if (discountAdhesion && [51, 52].includes(this.planId)) {
              this.descontoCupom = this.rechargeTaxTotal;
            } else if (discountAdhesion) {
              if (
                discountAdhesion.productId == C.SALES_TYPE.ADHESION ||
                discountAdhesion.productId == C.SALES_TYPE.GUARANTEE ||
                discountAdhesion.productId ==
                  C.SALES_TYPE.ADHESIONVEHICLEADDITIONAL
              ) {
                let qtd =
                  discountAdhesion.discountLimit == 0
                    ? this.order.vehicles.length
                    : Math.min(
                        this.order.vehicles.length,
                        discountAdhesion.discountLimit
                      );
                this.descontoCupom = qtd * discountAdhesion.valueUnitDiscount;
              } else {
                this.descontoCupom = discountAdhesion.valueUnitDiscount;
              }
            }
            if (this.descontoCupom > 0) {
              let d = this.order.products.find(function (o) {
                return o.productId == 11;
              });
              if (d) {
                d.valueTotal = -1 * this.descontoCupom;
                d.valueUnit = -1 * this.descontoCupom;
              } else {
                this.order.products.push({
                  productId: 11,
                  productName: "DESCONTO",
                  quantity: 1,
                  valueTotal: -1 * this.descontoCupom,
                  valueUnit: -1 * this.descontoCupom,
                });
              }
            }

            this.setPromotion(this.cupom);
            this.calculateTotal();
          })
          .catch((e) => {

            this.erroCupom = "Desconto não existe.";
            this.setPromotion(undefined);
          });

        this.$store.dispatch("loading", promise);
      }else{
        this.erroCupom = 'Valor da recarga não atende os requisitos para esse cupom.'
      }
    },

    handleInputChange() {
      this.erroCupom = "";
    },

    removeDiscount() {
      this.descontoCupom = 0;
      this.setPromotion(undefined);

      let i = this.order.products.findIndex((o) => o.productId == 11);
      if (i > 0) {
        this.order.products.splice(i, 1);
      }

      this.calculateTotal();
      this.cupom = "";
      this.erroCupom = "";
    },
    setPromotion(code) {
      if (this.order.promotionCode != "CAMINHOSDOPARANA") {
        this.order.promotionCode = code;
        if (!code) {
          this.order.promotionCode = undefined;
        }
      }
    },

    calculateTotal() {
      let t = 0;
      this.order.products.forEach(function (o) {
        t += parseFloat(o.valueTotal);
      });
      this.totalComDesconto = t;
      this.order.totalComDesconto = t;
    },
    checkValueMinForBF(){
      var findRecharge = this.order.products.find(product => product.productId == 2)
      if (findRecharge) {
        var promoCode = 'FR0'
        var valueByPlan = this.order.planId == 22 ? 9999 : this.order.planId == 32 ? 24999 : 0
        if(findRecharge.valueTotal > valueByPlan){
          var qtdPromo = Math.trunc(findRecharge.valueTotal / valueByPlan)
          var promoCodeFull = qtdPromo > 9 ? promoCode = 'FR' + qtdPromo : promoCode + qtdPromo

          return promoCodeFull
        }
      }
    },
    blackFridayCheck() {
      var promoCodeFull = this.checkValueMinForBF();
      if(promoCodeFull){
        let reqD = {
          promotionCode: promoCodeFull,
          planId: this.order.planId,
          salesType: this.order.salesType
        };
        sales.calculateDiscount(reqD).then(response => {
          this.promoBF = true;
          if(response.valid == 1){
            this.cupom = promoCodeFull
            this.setPromotion(promoCodeFull)
            this.calculateDiscount()
          }
        });
      }
    },
        calculatePercentValid(){
            if(this.contract){
              let percentRechargeValue
              if(this.contract.plan.newPlanId == 22){
                percentRechargeValue = 0.4
              }else if(this.contract.plan.newPlanId == 32){
                percentRechargeValue = 0.3
              }
              this.percentValid = this.resultBalance < (this.contract.rechargeValue * percentRechargeValue)
              return this.percentValid
            }
          }

  },
  components: {
    Payment,
    modalAddress,
  },
};



// WEBPACK FOOTER //
// ./src/pages/common/generic-summary.js